import cookies from 'js-cookie';
import KwaiLog  from '@kibt/weblogger/lib/log.browser';
// import KwaiLog  from '@kibt/weblogger';
import { isProduction, isTest } from './env';
import { getQuery } from './util';


const kpn = cookies.get('kpn') || 'KWAI';

let VUE_APP_LOG_TYPE = '';

if (isProduction) {
    VUE_APP_LOG_TYPE = 'oversea';
}

if (isTest) {
    VUE_APP_LOG_TYPE = 'test';
}


// 日志类型
enum LogType {
    show = 'SHOW',
    click = 'CLICK',
    pv = 'PV',
    // 雷达事件
    custom = 'CUSTOM',
}

export interface LogData {
    type: keyof typeof LogType;
    name: string;
    value?: Record<string, any>;
    eventId?: string;
    pvType?: 'enter' | 'leave' | 'hidden' | 'visible',
}

interface RadarLogData {
    // 事件名（必填）
    name: string;
    // 事件类型（可选）
    event_type?: string;
    // 业务分类（可选）
    category?: string;
    // 事件相关源文件（可选）
    src?: string;
    // 事件结果（可选）
    result_type?: string;
    // 消息（可选）
    message?: string;
    // 额外信息（建议使用json string - 可选）
    extra_info?: string;
    // 时长，可以计算分位数，不涉及可以不传（可选）
    duration?: number;
    videosrc?: string;
    event_count?: number;
}

type NetworkType = 'unknown' | 'none' | 'wifi' | '4g' | '3g' | '2g' | undefined;

type playType = 'playClicked' | 'playIDR' | 'playBlock' | 'playError';

// WebLogger内核SDK配置参数
const logConfig = {
    env: VUE_APP_LOG_TYPE || 'development' as any,
    retries: isProduction ? 3 : 0,
    autoPV: false,
    fps: false,
    logger: !isProduction,
    radar: {
        projectId: '4fedaf2ec1', // 雷达平台上的唯一标识
        sampling: 1, // 上报采样率，1 为全部上报
    },
};

// 公参配置
const baseOptions = {
    // version_name: cookies.get('appver') || '',
    // network_type: cookies.get('net') as NetworkType,
    // channel: cookies.get('c') || '',
    product_name: kpn,
    package_name: kpn,
    // user_id: cookies.get('userId') || cookies.get('ud') || '',
    /* h5_extra_attr: {
        county_name: {
            country: cookies.get('countryInfo') || 'UNKNOWN',
            bucket: cookies.get('bucket') || 'UNKNOWN',
        },
    }, */
};

function generateLogParams(data: LogData) {
    const info = {
        params: data.value,
        eventId: data.eventId,
    };

    const urlPage = data?.value?.urlPage;

    if (data.type === 'pv') {
        return {
            type: data.pvType,
            page: data.name,
            ...info,
        };
    }

    if (data.type === 'custom') {
        return {
            key: data.name,
            value: data.value,
            eventId: data.eventId,
        };
    }
    return {
        action: data.name,
        // urlPage: urlPage,
        ...info,
    };
}

let kwailog = null as any;

export function getKwaiLog() {
    if (!kwailog) {
        // const KwaiLog = require('@kibt/weblogger/lib/log.browser').default;
        kwailog = (new KwaiLog(logConfig, baseOptions)).weblog;
    }
    return kwailog;
}

/**
 * 数据上报
 * @param data 上报数据
 * @param immediate 是否立即上报
 */
const logCollect = (data: LogData, immediate?: boolean) => {
    const { type } = data;

    // 不存在类型则不上报
    if (!type) {
        return;
    }

    // 点击事件增加click_index字段，相同的share_id为一个生命周期
    if (type === 'click') {
        data.value = data.value || {};
        try {
            const deviceId = (cookies.get('_did') || '') as string;
            const shareId = `CLICK_INDEX_${getQuery()?.share_id}_${deviceId}`;
            const clickIndex = sessionStorage.getItem(shareId);
            const nextIndex = clickIndex ? `${+clickIndex + 1}` : '1';
            sessionStorage.setItem(shareId, nextIndex);
            data.value.click_index = nextIndex;
        } catch (error) {
            data.value.click_index = '-1';
        }
    }

    const logParams = generateLogParams(data);
    const logType = LogType[type];
    const webLogger = getKwaiLog();
    if (immediate) {
        webLogger.sendImmediately(logType, logParams as any);
    } else {
        webLogger.collect(logType, logParams as any);
    }
};


export const sendLog = (data: LogData) => {
    logCollect(data);
};


/**
 * 立即上报埋点
 * @param data
 */
export const immediateSendLog = (data: LogData) => {
    logCollect(data, true);
};

/**
 * 雷达上报：自定义事件
 */
export const radarLog = (data: RadarLogData) => {
    // message可能包含分享优化实验参数，有几种情况,other：不是低端机，lowDeviceOptimize：是低端机且命中优化实验，lowDeviceNotOptimize：是低端机未命中优化实验
    const { duration, message, event_count } = data;
    try {
        const webLogger = getKwaiLog();
        if (message?.includes('lowDeviceOptimize')) {
            webLogger?.plugins?.radar && webLogger.plugins.radar.setDimensions({
                c_dimension1: 'lowDeviceOptimize', // 值可以为任意string，且只支持string类型
            });
        } else if (message?.includes('lowDeviceNotOptimize')) {
            webLogger?.plugins?.radar && webLogger.plugins.radar.setDimensions({
                c_dimension1: 'lowDeviceNotOptimize', // 值可以为任意string，且只支持string类型
            });
        }

        webLogger?.plugins?.radar && webLogger.plugins.radar.event(data, {
            duration,
            event_count,
        });
    } catch (error) {
        console.error(error);
    }
};

const getReferPage = (pageName: string) => {
    try {
        const referPage = sessionStorage.getItem('SHARE_REFER_PAGE');
        const resRefer = referPage?.split(',') || [];

        // 路由面包屑，(当前页面刷新不计入次数)
        if (resRefer[resRefer.length - 1] !== pageName) {
            const nextRefer = referPage ? `${referPage},${pageName}` : pageName;
            sessionStorage.setItem('SHARE_REFER_PAGE', nextRefer);
            resRefer.push(pageName);
        }
        return resRefer;
    } catch (error) {
        return [pageName];
    }
    
};

const getReferSource = (query: any) => {
    try {
        const storageKey = `REFER_SOURCE_${query?.share_id}`;
        const referSource = sessionStorage.getItem(storageKey);
        if (referSource) {
            return referSource;    
        }

        const referer = document.referrer;
        if (referer) {
            sessionStorage.setItem(storageKey, referer);
        }
        return referer || '';
    } catch (error) {
        return '';
    }
};

/**
 * 获取通用的分享参数
 * 参考 https://docs.corp.kuaishou.com/k/home/VFUJ54jFHDk0/fcAA5n4T_T3McdcAZfTJXxLzy
 * @param query url query obj
 * @returns 
 */
export function getShareCommonParams(query, pageName?: string) {
    const deviceId = (cookies.get('_did') || '') as string;
    const web_uq = (cookies.get('web_uq') || '') as string;
    const web_pstr = (cookies.get('web_pstr') || '') as string;
    const share_id = (query?.share_id || (`${deviceId}_${new Date().getTime()}`)) as string;
    let share_channel =  query?.cc || 'default';
    if (Array.isArray(query?.cc)) {
        share_channel = query?.cc[query?.cc?.length - 1];
    }
    return {
        web_uq,
        web_pstr,
        share_item_info: query?.share_item_info || 0,
        share_uid: query?.share_uid || query?.fid || 0,
        share_id,
        share_timestamp: query?.timestamp || new Date().getTime(),
        share_device_id: query?.share_device_id || query?.share_did || 0,
        share_channel,
        share_item_type: query?.share_item_type || 0,
        fbclid: query?.fbclid, // 非枚举文本型,标识facebook一个分享卡片的唯一id
        refer_page: getReferPage(pageName), // ["XXX","XXX","XXX"]
        refer_source: getReferSource(query), // 非枚举文本型,三方的来源（记录http请求里三方的来源），string格式
    };
}

/**
 * 雷达上报：视频相关上报
 */
export const videoPlayLog = (type: playType, params?: any) => {
    try {
        const webLogger = getKwaiLog();
        webLogger?.plugins?.radar && webLogger.plugins.radar[type](params);
    } catch (error) {
        console.error(error);
    }
};

const radarLogPlayBlock = (logName: string) => {
    radarLog({
        name: logName,
        event_type: 'play_block',
        category: 'KWAI_SHARE',
        message: `${logName}视频卡顿次数`,
        src: window.location.pathname,
    });
};

const radarLogPlayError = (logName: string, videosrc: string) => {
    radarLog({
        name: logName,
        event_type: 'play_error',
        category: 'KWAI_SHARE',
        message: `${logName}视频报错次数, src=${videosrc}`,
        src: window.location.pathname,
    });
};

const handleRadarLogPlayBlock = event => {
    const target = event.target as HTMLVideoElement;
    const logName = (target && target.getAttribute('data-logname')) || 'COMMON';
    radarLogPlayBlock(logName);
};

const handleRadarLogPlayError = event => {
    const target = event.target as HTMLVideoElement;
    const logName = (target && target.getAttribute('data-logname')) || 'COMMON';
    const videoSrc = (target && target.src) || '';
    radarLogPlayError(logName, videoSrc);
};

export const addVideoEleLog = (videoEle: HTMLVideoElement) => {
    videoEle.addEventListener('stalled', handleRadarLogPlayBlock);
    videoEle.addEventListener('waiting', handleRadarLogPlayBlock);
    videoEle.addEventListener('error', handleRadarLogPlayError);
};

export const removeVideoEleLog = (videoEle: HTMLVideoElement) => {
    videoEle.removeEventListener('stalled', handleRadarLogPlayBlock);
    videoEle.removeEventListener('waiting', handleRadarLogPlayBlock);
    videoEle.removeEventListener('error', handleRadarLogPlayError);
};